package pl.decks.personal.components.widgets.hasdiagram

@Suppress("unused")
enum class HASLineDirection {
    INWARDS, OUTWARDS;
}
